import { useLocation } from 'react-router-dom';
import { Bell, Search, Filter, X } from 'lucide-react';
import { modules } from '../../theme/constants';
import { useFilter } from '../../context/FilterContext';

const pathLabels: Record<string, string> = {
  '/': 'Dashboard',
  '/members': 'Family Members',
  '/assets': 'Assets',
  '/liabilities-mgmt': 'Liabilities',
  ...Object.fromEntries(modules.map((m) => [m.path, m.label])),
};

export default function TopBar() {
  const location = useLocation();
  const pageTitle = pathLabels[location.pathname] || 'Osprey Legacy';
  const {
    entityFilter, memberFilter, setEntityFilter, setMemberFilter,
    clearFilters, entities, members, isFiltered,
  } = useFilter();

  return (
    <header className="h-14 bg-white border-b border-ivory-300 flex items-center justify-between px-6 sticky top-0 z-20">
      <div>
        <h2 className="font-display text-lg font-medium text-navy-800">
          {pageTitle}
        </h2>
      </div>

      <div className="flex items-center gap-3">
        {/* Entity Filter */}
        <div className="flex items-center gap-1.5">
          <Filter size={14} className={isFiltered ? 'text-gold-600' : 'text-navy-300'} />
          <select
            value={entityFilter}
            onChange={(e) => setEntityFilter(e.target.value)}
            className={`text-xs font-sans border rounded px-2 py-1 bg-ivory-100 focus:outline-none focus:border-navy-400 ${
              entityFilter ? 'border-gold-400 text-navy-800 font-semibold' : 'border-ivory-300 text-navy-500'
            }`}
            style={{ maxWidth: 160 }}
          >
            <option value="">All Entities</option>
            {entities.map(e => (
              <option key={e.id} value={e.id}>{e.name}</option>
            ))}
          </select>
          <select
            value={memberFilter}
            onChange={(e) => setMemberFilter(e.target.value)}
            className={`text-xs font-sans border rounded px-2 py-1 bg-ivory-100 focus:outline-none focus:border-navy-400 ${
              memberFilter ? 'border-gold-400 text-navy-800 font-semibold' : 'border-ivory-300 text-navy-500'
            }`}
            style={{ maxWidth: 150 }}
          >
            <option value="">All People</option>
            {members.map(m => (
              <option key={m.id} value={m.id}>{m.first_name} {m.last_name}</option>
            ))}
          </select>
          {isFiltered && (
            <button
              onClick={clearFilters}
              className="p-1 rounded hover:bg-red-50 text-navy-400 hover:text-red-600 transition-colors"
              title="Clear filters"
            >
              <X size={14} />
            </button>
          )}
        </div>

        <div className="w-px h-6 bg-ivory-300" />

        {/* Search */}
        <button className="p-2 text-navy-400 hover:text-navy-600 hover:bg-ivory-200 rounded-md transition-colors">
          <Search size={18} />
        </button>
        {/* Notifications */}
        <button className="p-2 text-navy-400 hover:text-navy-600 hover:bg-ivory-200 rounded-md transition-colors relative">
          <Bell size={18} />
        </button>
      </div>
    </header>
  );
}
